"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGEventHandler = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var bindings_1 = require("../../bindings");
var draw_state_1 = require("../../draw.state");
var util_draw_svg_1 = require("../../drawable/util.draw.svg");
var svg_event_translation_1 = require("./svg.event.translation");
var svg_move_1 = require("./svg.move");
var MAX_CLICK_MOVEMENT = 15;
var SVGEventHandler = /** @class */ (function () {
    function SVGEventHandler(dc, onStartHOASession) {
        this.onStartHOASession = onStartHOASession;
        this.lastRenderOptions = null;
        this.dc = dc;
    }
    SVGEventHandler.getStructure = function (evt) {
        var output = {
            id: null,
            label: null,
            tag: null,
            draggable: false,
            point: null,
            $event: null
        };
        if (evt.target == null) {
            return output;
        }
        var current = evt.target;
        var count = 0;
        while (current.parentNode != null) {
            var nodeId = current.getAttribute('c-Draw-node-id');
            if (output.id == null && nodeId != null) {
                output.id = nodeId;
                output.tag = current.getAttribute('c-Draw-tag');
            }
            var labelId = current.getAttribute('c-Draw-Label');
            if (labelId != null && output.label == null) {
                output.label = labelId;
                if (current.getAttribute('c-Draw-draggable') === 'true' || current.getAttribute('c-Draw-draggable') === true) {
                    output.draggable = true;
                }
            }
            // Label will be present before the node-id
            if (output.id && (output.label || count > 0)) {
                return output;
            }
            current = current.parentNode;
            count++;
        }
        return output;
    };
    SVGEventHandler.prototype.click = function ($event) {
        var _a, _b, _c, _d, _e;
        var dc = this.dc;
        var state = dc.state;
        var clickX = state.mouseDownX;
        var clickY = state.mouseDownY;
        if (clickX != null) {
            var diffXY = Math.abs(clickX - $event.clientX) + Math.abs(clickY - $event.clientY);
            if (diffXY > MAX_CLICK_MOVEMENT) {
                return;
            }
        }
        var ctx = SVGEventHandler.getStructure($event);
        var drawableId = ((ctx.label === util_draw_svg_1.IkeDrawLabel.LABEL) && ctx.id) ? ctx.id : undefined;
        var center = svg_event_translation_1.SVGEventTranslation.translateEvent($event);
        var tool = state.tool;
        if (this.dc.state.linkFieldIds.length > 0) {
            (_a = this.onStartHOASession) === null || _a === void 0 ? void 0 : _a.call(this);
            bindings_1.IkeDrawBindings.Measurement.Marker.create(dc, { drawableId: drawableId, center: center, $event: $event });
            if (dc.state.autoArrangeAnnotations && this.lastRenderOptions) {
                dc.state.arrangeAnnotations(this.lastRenderOptions);
            }
            return;
        }
        if (ctx.label === util_draw_svg_1.IkeDrawLabel.DELETE) {
            (_b = this.onStartHOASession) === null || _b === void 0 ? void 0 : _b.call(this);
            bindings_1.IkeDrawBindings.Measurement.delete(dc, { drawableId: ctx.id, $event: $event });
            return;
        }
        if (ctx.label === util_draw_svg_1.IkeDrawLabel.ACCEPT) {
            (_c = this.onStartHOASession) === null || _c === void 0 ? void 0 : _c.call(this);
            bindings_1.IkeDrawBindings.Measurement.accept(dc, { drawableId: ctx.id, $event: $event });
            dc.state.setAutoArrangeAnnotations(dc.drawState.hasOnlyInsightDetections());
            return;
        }
        if (tool === draw_state_1.IkeDrawTool.BASE || tool === draw_state_1.IkeDrawTool.MARKER) {
            // Note that the UI currently forces the tool to be BASE until a base exists,
            // which means if the tool is MARKER, then a base must already be set.
            var highlightedId = state.hoverId;
            // If clicking on an approvable insight drawable, then approve it.
            if (highlightedId && highlightedId !== 'image') {
                if (!dc.drawState.hasDrawable(highlightedId)) {
                    return;
                }
                var drawable = dc.drawState.getDrawable(highlightedId);
                if (drawable.isApprovableInsightDrawable() && drawable.isInsightBaseOffsetDetectionClass) {
                    (_d = this.onStartHOASession) === null || _d === void 0 ? void 0 : _d.call(this);
                    drawable.approveInsightFlag();
                }
            }
            else {
                // User is clicking on empty space, so create a new base or marker.
                (_e = this.onStartHOASession) === null || _e === void 0 ? void 0 : _e.call(this);
                bindings_1.IkeDrawBindings.Measurement.Marker.create(dc, { drawableId: drawableId, center: center, $event: $event });
                if (dc.state.autoArrangeAnnotations && this.lastRenderOptions) {
                    dc.state.arrangeAnnotations(this.lastRenderOptions);
                }
            }
            return;
        }
        if (tool === draw_state_1.IkeDrawTool.LINE) {
            bindings_1.IkeDrawBindings.Measurement.Line.create(dc, { drawableId: drawableId, center: center, $event: $event });
            if (dc.state.autoArrangeAnnotations && this.lastRenderOptions) {
                dc.state.arrangeAnnotations(this.lastRenderOptions);
            }
            return;
        }
    };
    SVGEventHandler.prototype.doubleclick = function ($event) {
        var ctx = SVGEventHandler.getStructure($event);
        if (ctx.id == null || ctx.label !== util_draw_svg_1.IkeDrawLabel.LABEL) {
            return;
        }
        var dc = this.dc;
        var state = dc.state;
        state.propertiesShow(ctx.id);
    };
    SVGEventHandler.prototype.mousedown = function (evt) {
        var _this = this;
        var ctx = SVGEventHandler.getStructure(evt);
        var dc = this.dc;
        var state = dc.state;
        state.mouseDownX = evt.clientX;
        state.mouseDownY = evt.clientY;
        if (ctx.id && evt.which === 1 && ctx.tag !== 'image') {
            var object = dc.drawState.getDrawable(ctx.id);
            if (object == null) {
                return;
            }
            if (ctx.label == null) {
                dc.state.setSelected(null, null);
            }
            else {
                // If the base tool is selected, then we don't want to be able to select any other drawable
                if (state.tool !== draw_state_1.IkeDrawTool.BASE) {
                    dc.state.setSelected(ctx.id, ctx.label);
                }
                else {
                    var drawable = dc.drawState.getDrawable(ctx.id);
                    if (drawable.isApprovableInsightDrawable() && drawable.isInsightBaseOffsetDetectionClass) {
                        dc.state.setSelected(ctx.id, ctx.label);
                    }
                }
            }
        }
        else {
            dc.state.setSelected(null, null);
        }
        if (ctx.id == null || ctx.draggable !== true) {
            return;
        }
        ctx.$event = evt;
        // Start listening for move events.
        var mover = svg_move_1.SVGMove.create(this.dc, ctx);
        if (mover == null) {
            return;
        }
        state.moveId = ctx.id;
        mover.onMove = function () {
            bindings_1.IkeDrawBindings.Selection.move(dc, {
                label: ctx.label,
                delta: mover.delta,
                $event: null
            });
            if (ctx.label === util_draw_svg_1.IkeDrawLabel.LABEL) {
                dc.state.setAutoArrangeAnnotations(false);
            }
        };
        mover.onStart = function () {
            var _a;
            (_a = _this.onStartHOASession) === null || _a === void 0 ? void 0 : _a.call(_this);
        };
        mover.start();
        mover.onEnd = function () {
            if (dc.state.autoArrangeAnnotations && ctx.label !== util_draw_svg_1.IkeDrawLabel.LABEL && _this.lastRenderOptions) {
                dc.state.arrangeAnnotations(_this.lastRenderOptions);
            }
        };
    };
    SVGEventHandler.prototype.mousemove = function (evt) {
        var ctx = SVGEventHandler.getStructure(evt);
        var state = this.dc.state;
        if (ctx.id == null) {
            state.setHovered(null);
            return;
        }
        // If the base tool is selected, then we don't want to be able to select any other drawable
        if (state.tool === draw_state_1.IkeDrawTool.BASE) {
            var drawable = this.dc.drawState.getDrawable(ctx.id);
            if (drawable.isApprovableInsightDrawable() && !drawable.isInsightBaseOffsetDetectionClass) {
                state.setHovered(null);
                return;
            }
        }
        var highlightedId = state.hoverId;
        var currentMove = state.moveId;
        if (currentMove != null) {
            return;
        }
        if (highlightedId == null && ctx.id == null ||
            (highlightedId && ctx.id === highlightedId)) {
            // Not moving and the highlighted ID is the same
            return;
        }
        state.setHovered(ctx.id);
    };
    SVGEventHandler.prototype.mousewheel = function (delta, $event) {
        var dc = this.dc;
        bindings_1.IkeDrawBindings.Image.zoom(dc, {
            delta: delta,
            center: svg_event_translation_1.SVGEventTranslation.translateEvent($event),
            $event: $event
        });
    };
    tslib_1.__decorate([
        mobx_1.action.bound
    ], SVGEventHandler.prototype, "click", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], SVGEventHandler.prototype, "doubleclick", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], SVGEventHandler.prototype, "mousedown", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], SVGEventHandler.prototype, "mousemove", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], SVGEventHandler.prototype, "mousewheel", null);
    return SVGEventHandler;
}());
exports.SVGEventHandler = SVGEventHandler;
//# sourceMappingURL=svg.event.js.map